import { CaseStudy, SectionEyebrow } from "@/components/Landing/primitives";

const CASE_STUDIES = Object.freeze([
    {
        id: "bess-vic",
        title: "Tier 1 Principal \u2014 Battery Energy Storage, Victoria",
        sector: "Grid-scale BESS construction",
        modules: "Full platform + SENTINEL",
        outcome:
            "Real-time safety and compliance visibility across principal and 40+ contractor companies.",
    },
    {
        id: "bess-nsw",
        title: "Tier 1 Principal \u2014 Battery Energy Storage, NSW",
        sector: "Grid-scale BESS construction",
        modules: "Full platform + SENTINEL",
        outcome:
            "Critical risk control verification moved from monthly reporting to live dashboard.",
    },
]);

export default function CustomerProof() {
    return (
        <section
            id="customers"
            className="relative py-24 sm:py-32 bg-white text-[#0A0A0A] border-t border-zinc-200"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl reveal">
                    <SectionEyebrow>Customer proof</SectionEyebrow>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1] mt-3">
                        Trusted on projects of consequence.
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-2 gap-5">
                    {CASE_STUDIES.map((cs) => (
                        <CaseStudy
                            key={cs.id}
                            title={cs.title}
                            sector={cs.sector}
                            modules={cs.modules}
                            outcome={cs.outcome}
                        />
                    ))}
                </div>

                <p className="mt-8 text-sm text-zinc-600 reveal">
                    Selected via competitive tender. Reference details
                    available under NDA on request.
                </p>
            </div>
        </section>
    );
}
